import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCompetencies',
    pure: false,
    standalone: false
})
export class FilterCompetenciesPipe implements PipeTransform {
    transform(items: any, filter: string): any {
        if (!items || !filter) {
            return items;
        }
        return items.filter(item => item.Domain.indexOf(filter) !== -1);
    }
}
